<template>
  <div class="download" ref="downloadWrap">
    <div class="img-title">
      <img src="../assets/logo.png" alt/>
      <img src="../assets/image/mobile-des.png" alt/>
    </div>
    <div class="img-main">
      <img src="../assets/image/banner.png" alt/>
    </div>
    <div class="btn-down">
      <div class="btn recharge-btn" @click="openRecharge()">
        <span>默往币充值入口</span>
      </div>
      <div class="btn" @click="download()">
        <img src="../assets/download.png"/>
        <span>立即下载</span>
      </div>
      <div class="btn" @click="openApp()">
        <img src="../assets/image/send.png" alt/>
        <span>已下载，打开APP</span>
      </div>
    </div>
    <footer class="download-footer">
      <nav class="footer-nav">
        <router-link exact to="/" active-class="" exact-active-class="">首页</router-link>
        <span class="nav-sep"> | </span>
        <router-link to="/features" active-class="" exact-active-class="">功能特性</router-link>
        <span class="nav-sep"> | </span>
        <router-link to="/download" active-class="" exact-active-class="">下载APP</router-link>
        <span class="nav-sep"> | </span>
        <a
          class="footer-news-nav-link"
          :class="{ current: isNewsFooterActive }"
          href="/news/"
        >新闻动态</a>
      </nav>
    </footer>
    <canvas id="moveImg"></canvas>
    <!--    <img id="leftTop" style="display:none" class="left-top" src="../assets/image/tuiyuan.png" alt/>-->
    <!--    <img id="rightBottom" class="right-bottom" style="display:none" src="../assets/image/square.png" alt/>-->
    <img class="left-top" src="../assets/image/tuiyuan.png" alt />
    <img class="right-bottom" src="../assets/image/square.png" alt />

    <div class="mask" @click="show = false" v-show="show">
      <img class="arrow" src="../assets/arrow@3x.png" alt srcset/>
      <div class="know">
        <div>请点击右上角三个点</div>
        <div>选择在浏览器中打开</div>
      </div>
    </div>
  </div>
</template>

<script>

import { getDownUrl } from '@/api/apply'

export default {
  name: 'Download',
  metaInfo: {
    title: '下载默往 APP - iOS/Android/Windows/macOS 全平台加密聊天工具',
    meta: [
      {
        vmid: 'keywords',
        name: 'keywords',
        content: '默往下载，加密聊天 APP 下载，iOS 聊天软件，Android 聊天软件，跨平台通讯工具'
      },
      {
        vmid: 'description',
        name: 'description',
        content: '立即下载默往加密聊天 APP，支持 iOS、Android、Windows、macOS 全平台。端到端加密保护您的隐私，扫码或点击下载按钮快速获取安全通讯工具。'
      },
      { vmid: 'author', name: 'author', content: '厦门默往科技有限公司' },
      { vmid: 'robots', name: 'robots', content: 'index, follow' },
      { vmid: 'renderer', name: 'renderer', content: 'webkit' },
      // Open Graph
      { vmid: 'og:title', property: 'og:title', content: '下载默往 APP - iOS/Android/Windows/macOS 全平台加密聊天工具' },
      { vmid: 'og:description', property: 'og:description', content: '支持 iOS、Android、Windows、macOS 全平台下载，端到端加密保护您的隐私' },
      { vmid: 'og:type', property: 'og:type', content: 'website' },
      { vmid: 'og:url', property: 'og:url', content: 'https://www.mowangim.com/download' },
      { vmid: 'og:image', property: 'og:image', content: 'https://www.mowangim.com/images/og-image.jpg' },
      // Twitter Card
      { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      { vmid: 'twitter:title', name: 'twitter:title', content: '下载默往 APP - iOS/Android/Windows/macOS 全平台加密聊天工具' },
      { vmid: 'twitter:description', name: 'twitter:description', content: '支持 iOS、Android、Windows、macOS 全平台下载' }
    ],
    link: [
      { vmid: 'canonical', rel: 'canonical', href: 'https://www.mowangim.com/download' }
    ]
  },
  data () {
    return {
      show: false,
      ctx: null,
      animationObj: [],
      andDownUrl: ''
    }
  },
  created () {
    // document.title is now managed by vue-meta
    this.initDownUrl()
  },
  computed: {
    isNewsFooterActive () {
      return /^\/news(?:\/|$)/.test(window.location.pathname)
    }
  },
  methods: {
    initDownUrl () {
      getDownUrl().then(res => {
        this.andDownUrl = res.data.android
      }).catch(err => {
        console.error('获取下载链接失败', err)
      })
    },
    download () {
      if (this.isWeiXin()) {
        this.show = true
        return
      }
      if (this.isDouyinBrowser()) {
        this.show = true
      }
      let channel = this.$route.query.channel
      var u = window.navigator.userAgent
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        window.location.href = 'https://apps.apple.com/cn/app/id1408526658'
      } else {
        if (channel) {
          window.location.href = `http://okimg.mostonetech.top/apks/mostone_release_${channel}.apk`
        } else {
          window.location.href = this.andDownUrl || 'http://okimg.mostonetech.top/apks/mostone_release_local.apk'
        }
      }
    },
    openRecharge () {
      window.open('/coin/recharge?screen=full', '_blank')
    },
    openApp () {
      let type = this.$route.query.type
      let data = this.$route.query.data
      if (this.isWeiXin() || this.isDouyinBrowser()) {
        this.show = true
      } else {
        window.location.href =
          'mostone://life.com/notice?type=' + type + '&data=' + data
      }
    },
    isDouyinBrowser () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.includes('aweme') || ua.includes('tiktok') // 同时覆盖抖音和TikTok
    },
    isWeiXin () {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    loop () {
      this.ctx.clearRect(0, 0, this.$refs.downloadWrap.clientWidth, this.$refs.downloadWrap.clientHeight)
      this.ctx.fillStyle = 'rgba(61, 249, 193, 0.1)'
      this.ctx.fillRect(0, 0, this.$refs.downloadWrap.clientWidth, this.$refs.downloadWrap.clientHeight)

      for (let i = 0; i < this.animationObj.length; i++) {
        this.animationObj[i].draw(this.ctx)
        this.animationObj[i].update(this.ctx)
      }
      requestAnimationFrame(this.loop)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

#moveImg {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.download {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  /*background-image: url("../assets/wap_bg.png");*/
  background-size: 100% 100%;
  background: rgba(61, 249, 193, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: relative;

  .img-title {
    padding-top: px2rem(40);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    img:first-child {
      width: px2rem(160);
      // height: 98px;
      margin-bottom: px2rem(10);
    }

    img:last-child {
      width: px2rem(372);
    }
  }

  .img-main {
    width: 100%;
    padding: 0 px2rem(20);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      margin: auto;
      margin-bottom: 0;
    }
  }

  .btn-down {
    padding-bottom: px2rem(20);
    .btn {
      width: px2rem(600);
      height: px2rem(100);
      border-radius: px2rem(300);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: px2rem(32);
      background: #00d394;
      margin-bottom: px2rem(20);
      &:last-child {
        background: none;
        color: #000;
        margin-bottom: 0;
      }

      &:active {
        background: #24e8ae;
      }

      img {
        width: px2rem(28);
        margin-right: px2rem(10);
      }
    }

    .recharge-btn {
      background: #ffffff;
      color: #00b77f;
      border: 1px solid rgba(0, 211, 148, 0.3);
      box-shadow: 0 px2rem(10) px2rem(24) rgba(0, 211, 148, 0.12);

      &:active {
        background: #f2fffb;
      }
    }
  }

  .download-footer {
    width: 100%;
    padding: px2rem(10) px2rem(24) px2rem(24);
    color: #6D6F76;
    font-size: px2rem(24);
    line-height: 1.8;
    text-align: center;
    box-sizing: border-box;

    a {
      color: #6D6F76;
      text-decoration: none;
      padding: 0 px2rem(8);
    }

    .footer-news-nav-link {
      color: #10b981;
    }

    .footer-news-nav-link:hover,
    .footer-news-nav-link:active {
      color: #10b981;
      text-decoration: underline;
    }

    .footer-news-nav-link.current {
      color: #10b981;
      font-weight: 700;
      text-decoration: underline;
    }

    .nav-sep {
      color: #9ca3af;
    }
  }

  .left-top {
    position: absolute;
    width: 200px;
    left: -120px;
    top: -20px;
    z-index: -1;
    animation: rotateLeft 15s linear infinite;
  }

  .right-bottom {
    position: absolute;
    width: 200px;
    right: -120px;
    bottom: -20px;
    z-index: -1;
    animation: rotateRight 15s linear infinite;
  }

  @keyframes rotateLeft {
    0% {
      transform: rotate(0);
      left: -120px;
      top: -20px;
    }
    50% {
      left: -20px;
      top: -120px;
      transform: rotate(180deg);
    }
    100%{
      transform: rotate(360deg);
      left: -120px;
      top: -20px;
    }
  }

  @keyframes rotateRight {
    0% {
      right: -120px;
      bottom: -20px;
    }
    50% {
      right: -20px;
      bottom: -120px;
    }
    100%{
      right: -120px;
      bottom: -20px;
    }
  }

  .mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.7);
    color: #fff;
    z-index: 100000;

    .arrow {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 60px;
    }

    .know {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 50px;
      top: 80px;
      font-size: 16px;
      color: #fff;
    }
  }
}
</style>
